import { withTranslation } from "react-i18next";
import withRouter from "./withRouter";
import { flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { Table } from "reactstrap";


const TableWithoutPagination = (
    {divClassNames, columns, data, tableClassName, tableHeadClassName, tableBodyClassName, tdClass}) => {
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel()
    })
    const { getHeaderGroups, getRowModel } = table;

    return (
        <div className={divClassNames}>
            
            <Table className={tableClassName}>
                <thead className={tableHeadClassName}>
                    {getHeaderGroups().map((headerGroup) => {
                        return (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header) => {
                                    return (
                                        <th id={header.id}>
                                            {header.isPlaceholder ? null
                                                : flexRender(
                                                header.column.columnDef.header,
                                                header.getContext(),
                                            )}
                                        </th>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </thead>
                <tbody className={tableBodyClassName}>
                    {data && data.length > 0 ? (
                        getRowModel().rows.map((row) => (
                            <tr key={row.id}>
                                {row.getVisibleCells().map((cell) => (
                                    <td className={tdClass} key={cell.id}>
                                        {flexRender(
                                            cell.column.columnDef.cell,
                                            cell.getContext()
                                        )}
                                    </td>
                                ))}
                            </tr>)))
                            : (
                            <tr>
                                <td className="justify-content-center" colSpan={columns.length}>
                                    <p className="d-flex justify-content-center">
                                        No data found
                                    </p>
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        </div>
    );
}

export default withRouter(withTranslation()(TableWithoutPagination));